import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

import { default as LanguageSelector } from '@plone/volto/components/theme/LanguageSelector/LanguageSelector';
import { default as UniversalLink } from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import {
  faArrowRightFromBracket,
  faUser,
  faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const MobileToolsFooter = ({ token, locale }) => {
  const user = useSelector((state) => state.users.user);
  return (
    <>
      <div className="private-area-mobile">
        {token ? (
          <Dropdown
            multiple
            trigger={
              <>
                <FontAwesomeIcon
                  style={{ maxWidth: '15px', height: '1em' }}
                  className="primary"
                  icon={faUser}
                />{' '}
                {token ? (
                  <>
                    {user.fullname}{' '}
                    <FontAwesomeIcon
                      style={{ maxWidth: '15px', height: '1em' }}
                      icon={faChevronDown}
                    />
                  </>
                ) : (
                  <FormattedMessage
                    id="Private area"
                    defaultMessage="Private area"
                  />
                )}
              </>
            }
          >
            <Dropdown.Menu>
              <Dropdown.Menu scrolling>
                <Dropdown.Item
                  text={
                    <UniversalLink href={`/${locale}/private-area`}>
                      <FontAwesomeIcon
                        style={{ maxWidth: '15px', height: '1em' }}
                        className="primary"
                        icon={faUser}
                      />{' '}
                      <FormattedMessage
                        id="Private area"
                        defaultMessage="Private area"
                      />
                    </UniversalLink>
                  }
                />
                <Dropdown.Item
                  text={
                    <UniversalLink href={`/${locale}/logout`}>
                      <FontAwesomeIcon
                        style={{ maxWidth: '15px', height: '1em' }}
                        className="danger"
                        icon={faArrowRightFromBracket}
                      />
                      <FormattedMessage id="Log out" defaultMessage="Log out" />
                    </UniversalLink>
                  }
                />
              </Dropdown.Menu>
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <UniversalLink href={`/${locale}/login`}>
            <FontAwesomeIcon
              style={{ maxWidth: '15px', height: '1em' }}
              className="primary"
              icon={faUser}
            />{' '}
            <FormattedMessage id="Private area" defaultMessage="Private area" />
          </UniversalLink>
        )}{' '}
      </div>
      <ul className="mobile-tools">
        <li>
          <LanguageSelector fullLabel={true} />
        </li>
      </ul>
    </>
  );
};
